import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const addClassFormSchema = z.object({
  className: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.addClass.className.required)
    .min(2, VALIDATION_MESSAGES.addClass.className.min)
    .max(50, VALIDATION_MESSAGES.addClass.className.max),

  assignedTeachers: z.array(z.string()).optional(),

  classTeacher: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.addClass.classTeacher.required),
});

export type TAddClassForm = z.infer<typeof addClassFormSchema>;
